import React, { useEffect, useState, useRef } from 'react';
import { Navigate, useNavigate } from 'react-router';
import Alert from './Alert';
import { FiDollarSign, FiEdit, FiX, FiCheckCircle, FiXCircle, FiPlusCircle } from "react-icons/fi";
import ItemYORP from './ItemYORP';
import { Link } from "react-router-dom";

import { db, auth, storage } from '../functions/firebaseFunctions'

const AccTypes = ['Standard', 'Artist', 'Business'];
const accTypesDis = {
  Standard: 'Create events, book entertainments and venues',
  Artist: 'Provide entertainments services for events',
  Business: 'Rent out your venues for events',
};

const EditProfileScreen = ({ navigation, route }) => {

  let timeout;
  useEffect(() => {
    getStripeAccount();
    // getUserSubscriptions()
    getUserInfo();
    getData();
    return function cleanup() {
      clearTimeout(timeout);
    };
  }, []);

  const [savingMsg, showSavingMsg] = useState(false);
  const [scsMsg, showScsMsg] = useState(false);
  const [scsMsgArt, showScsMsgArt] = useState(false);
  // const [Err, setErr] = useState(null);
  const [image, setImage] = useState(null);
  // const [name, setname] = useState('');

  const [bio, setBio] = useState('');

  const [sp, setsp] = useState('');
  const [yt, setyt] = useState('');
  const [sc, setsc] = useState('');
  const [mix, setmix] = useState('');
  // const [changes, setChanges] = useState(false);

  const [Err, setErr] = useState(null);

  const [changes, setChanges] = useState(false);
  const [artChanges, setArtChanges] = useState(false);
  const uid = auth.currentUser?.uid
  console.log(uid)

  const [email, setemail] = useState('');
  const [nemail, setnemail] = useState('');
  const [name, setname] = useState('');
  const [nname, setnname] = useState('');
  const [fbook, setFaceBook] = useState('');
  const [inst, setinst] = useState('');
  const [phN, setphN] = useState('');
  const [In, setin] = useState('');
  const [twit, settwit] = useState('');
  const [loader, setLoader] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [alert, setAlert] = useState(null);

  const [AccType, setAccType] = useState('Standard');
  const [PAccType, setPAccType] = useState('Standard');
  const [accTypeSelShow, setAccTypeSelShow] = useState(false);
  const [isMobilePay, setIsMobilePay] = useState(false);
  const navigateTo = useNavigate();

  const [search, setSearch] = useState(false);
  const [places, setPlaces] = useState([]);
  const fileInput = useRef(null);


  const getStripeAccount = () => {
    if (auth.currentUser) {
      db
        .collection('users')
        .doc(auth.currentUser?.uid)
        .get()
        .then(async (doc) => {
          const val = doc.data();
          if (doc.exists) {
            if (val.mobile_pay_activation) {

              setIsMobilePay(true);
            }
          }
        });
    }

  };

  const getUserSubscriptions = () => {
    const uid = auth.currentUser.uid
    db.collection('users').doc(uid)
      .onSnapshot((user) => {

        //  let temp=[]
        if (user.data()?.subscription?.length > 0) {
          // setPlaces(user.data().subscription)
        }
        //  setPlaces(user.data().subscription)
      });

    // .catch((error) => {
    //     console.error("Error writing document: ", error);
    // });
  };
  const select = (item) => {
    const arr = places;
    const uid = auth.currentUser.uid
    setSearch(false);
    const update = {
      state: item.state,
      town: item.town,
      name: item.name,
      id: item.id,
    };
    arr.push(update);

    db.collection('users').doc(uid).set({
      subscription: arr,
    }, { merge: true })
      .then(() => {
        console.log('Document successfully written!');
      })
      .catch((error) => {
        console.error('Error writing document: ', error);
      });

  };
  const getData = async () => {
    let UID;
    showSavingMsg(false);
    const user = auth.currentUser;
    if (user) {

      setname(user.displayName);
      setImage(user.photoURL);
      if (user.photoURL) {
        await fetch(user.photoURL).then(response => response)
          .then(data => {

            if (data?.error?.message == 'Permission denied.') {
              setImage(null);
            }
          }).catch(err => console.log('image fetch error', err));
      }
      UID = user?.uid;
    } else {
      showScsMsg(false);
    }
    db.collection('users').doc(UID).get().then((res) => {
      if (res.exists) {
        const val = res.data().artist;
        if (val) {
          if (val.bio != undefined) { setBio(val.bio); }
          if (val.yt != undefined) { setyt(val.yt); }
          if (val.sp != undefined) { setsp(val.sp); }
          if (val.sc != undefined) { setsc(val.sc); }
          if (val.mix != undefined) { setmix(val.mix); }
        }
      }

    }).catch((e) => { setErr(e); });
  };
  // useEffect(() => {
  //   return function cleanup() {
  //     clearTimeout(timeout);
  //   };
  // });

  const uploadImage = async (avatar) => {
    showSavingMsg(true);
    // console.log('avava', avatar.files[0])
    const blob = new Blob([avatar.files[0]], { type: avatar.files[0].type });

    const u = auth.currentUser;
    const uid = u.uid;
    // console.log('uid:', uid)

    const ref = db.collection('users').doc(uid);
    // Upload the blob to Firebase Storage and get the download URL
    const storageRef = storage.ref(`users/${uid}/avatar`);
    const snapshot = await storageRef.put(blob);
    const url = await snapshot.ref.getDownloadURL();

    // Update the user document in Firestore with the download URL
    ref.update({photo: url}).then(() => {
      showSavingMsg(false);
      showScsMsg(true);
      timeout = setTimeout(() => { showScsMsg(false);  }, 3000);

      // Update the user profile photoURL
      u.updateProfile({ photoURL: url }).catch(function (e) {
        setErr(e);
        console.log('error', e)
      });
    }).catch((err) => { setErr(err); });
  };

  const getUserInfo = async () => {
    setLoader(true);
    showSavingMsg(false);
    // if (image) { uploadImage(); } //todo
    
    const uid = auth.currentUser?.uid;//get user id from authentification
    db.collection('users').doc(uid).get()
      .then(async (user) => {
        let userData = user.data();
        // console.log('userData photo', userData.photo)
        if (userData) {
          setemail(userData.email);
          setnemail(userData.email);
          setname(userData.name);
          setnname(userData.name);
          setImage(userData.photo);

          let img = userData.photo;
          if (img) {
            await fetch(userData.photo).then(response => response)
              .then(data => {

                if (data?.error?.message == 'Permission denied.') {
                  setImage(null);
                }
              }).catch(err => console.log('image fetch error', err));
          }

          if (userData.fb) { setFaceBook(userData.fb); }
          if (userData.inst) { setinst(userData.inst); }
          if (userData.in) { setin(userData.in); }
          if (userData.phN) { setphN(userData.phN); }
          if (userData.twit) { settwit(userData.twit); }
          if (userData.type) {
            setAccType(userData.type);
            setPAccType(userData.type);
          }
          if (user.subscription) {
            const size = user.subscription?.length;
            let counter = 0;
            const arr = [];

            user.subscription?.map(item => {

              counter++;
              arr.push({ state: item.state, town: item.town, name: item.name, id: item.id });
            });
            if (counter == size) {
              setPlaces(arr);
            }
          }

        } else {
          showScsMsg(false);
        }
      }).catch((e) => { setErr(e); });
    setLoader(false);

  };
  const editArtist = async event => {
    event.preventDefault();

    const bioInput = document.querySelector('#bio');
    const bio = bioInput.value;
    setBio(bio);
    
    const ytInput = document.querySelector('#yt');
    const yt = ytInput.value;
    setyt(yt);
    
    const spInput = document.querySelector('#sp');
    const sp = spInput.value;
    setsp(sp);
    
    const scInput = document.querySelector('#sc');
    const sc = scInput.value;
    setsc(sc);
    
    const mixInput = document.querySelector('#mix');
    const mix = mixInput.value;
    setmix(mix);

    bio || yt || sp || sc || mix && setArtChanges(true);
    setErr(null);
    showSavingMsg(true);
    showScsMsgArt(false);
    // console.log(artChanges)

    if (artChanges == true) {
      const update = {};
      if (bio) { update.bio = bio; } else { update.bio = null; }
      if (yt) { update.yt = yt; } else { update.yt = null; }
      if (sp) { update.sp = sp; } else { update.sp = null; }
      if (sc) { update.sc = sc; } else { update.sc = null; }
      if (mix) { update.mix = mix; } else { update.mix = null; }

        db.collection('users').doc(uid).update({ artist: update })
    .then((res) => {
      showScsMsgArt(true);
      timeout = setTimeout(() => { 
        showScsMsgArt(false);
      }, 3000);
      setArtChanges(false);
    })
    .catch((e) => {
      setErr(e);
    });

    }
    setArtChanges(false);
    showSavingMsg(false)
    
  }

  const edit = async event => {
    event.preventDefault()
    const { avatar } = event.target
    // console.log('avatar', avatar)
    avatar && uploadImage(avatar)
    const uid = auth.currentUser.uid
    showSavingMsg(true);
    // if (image) { uploadImage(); } //todo
    if (changes) {
      const update = {};
      if (In) { update.in = In; } else { update.in = null; }
      if (nname) { update.name = nname; } else { update.name = null; }
      if (fbook) { update.fb = fbook; } else { update.fb = null; }
      if (inst) { update.inst = inst; } else { update.inst = null; }
      if (phN) { update.phN = phN; } else { update.phN = null; }
      if (twit) { update.twit = twit; } else { update.twit = null; }
      if (nemail) { auth.currentUser?.updateEmail(nemail)
        .then(function() { db.collection('users').doc(uid).update({email: nemail})
        }).catch(e=>{ setErr(e) });
      } else {setErr({code:'EmptyEmail',message:'Provide an e-mail address'}); update.email = null; }

      // console.log('test:', In, nname, fbook, inst, phN, twit, 'email:', email)
      db.collection('users').doc(uid).update(update).then((x) => {
        // console.log('this happend')
        showScsMsg(true);
        timeout = setTimeout(() => { 
          showScsMsg(false);
        }, 3000);
        showSavingMsg(false);
      }).catch((err) => {

      });
      auth.currentUser.updateProfile({
        displayName: nname,
      });
    }

    if (AccType !== PAccType) {

      if (PAccType === 'Artist') {
        const uid = auth.currentUser?.uid
        db.collection('services').doc(uid)
          .onSnapshot((doc) => {

            if (doc.data()) {
              setAlert({
                title: 'You have registered services',
                comment: 'If you switch to another type of account registered services will be deleted',
                options: [
                  { text: 'Cancel', onClick: () => { setAccType(PAccType); }, style: 'cancel' },
                  {
                    text: 'Delete', onClick: () => {
                      db.collection('services').doc(uid).delete().then(() => {
                        console.log('Document successfully deleted!');

                      }).catch((error) => {
                        console.error('Error removing document: ', error);
                      });
                    }, style: 'destructive',
                  },
                ],
              });
            }
          });

      }
      if (PAccType === 'Business') {
        db.collection('users').doc(uid).get().then((res) => {

          if (res.data().venues.length > 0) {
            let vens = res.data().venues;
            setAlert({
              title: 'You have registered venues',
              comment: 'If you choose to keep the venues they will not show up in the search until you switch back to the business account',
              options: [
                { text: 'Cancel', onClick: () => { setAccType(PAccType); }, style: 'cancel' },
                {
                  text: 'Keep Venues', onClick: () => {
                    vens?.map((r) => {

                      db.collection('venue').where('venueId', '==', r.Id).get().then((v) => {
                        if (v?.docs?.length > 0) {
                          let docid = v?.docs[0].data().docid;
                          db.collection('venue').doc(docid).update({ status: 'archived' }).then(() => { }).catch(e => { setErr(e); });
                        }

                      }).catch(e => { setErr(e); });
                    });

                  }, style: 'default',
                },
                {
                  text: 'Delete Venues', onClick: () => {
                    vens?.map((r) => {
                      if (r.id) {
                        db.collection('venue').where('venueId', '==', r.Id).get().then((v) => {
                          if (v?.docs?.length > 0) {
                            let docid = v?.docs[0]?.data()?.docid;
                            db.collection('venue').doc(docid).delete().then(() => { }).catch(e => { setErr(e); });
                          }

                        }).catch(e => { setErr(e); });
                      }

                    });
                  }, style: 'destructive',
                },
              ],
            });
          }
        }).catch(e => { setErr(e); });

      }
      if (AccType === 'Business') {
        db.collection('users').doc(uid).get().then((res) => {
          if (res.data().venues?.length > 0) {
            let vens = res.data()?.venues;
            vens?.map(item => {
              db.collection('venue')
                .where('venueId', '==', item.Id)
                .get().then((res) => {
                  if (res?.docs?.length > 0) {
                    let docid = res.docs[0].data().docid;
                    db.collection('venue').doc(docid).update({ status: null }).then(() => { }).catch((e) => setErr(e));
                  }

                }).catch(e => { setErr(e); });
            });
          }
        }).catch(e => { setErr(e); });
      }
      if (AccType === 'Standard') {
        db.collection('users').doc(uid).set({ type: null }, { merge: true }).then(() => { }).catch(e => setErr(e));

      } else {
        db.collection('users').doc(uid).set({ type: AccType }, { merge: true }).then(() => { }).catch(e => setErr(e));

      }
    }
    setChanges(false);
  };
  const renderPlacesSubscribed = () => {
    const uid = auth.currentUser?.uid
    if (places.length > 0) {
      return (
        places.map(place =>
          <div key={place.id}>
            <button item={place}
              onClick={() => {
                let temp = places;
                temp = places.filter(x => x.id !== place.id);
                setPlaces(temp);
                db.collection('users').doc(uid).set({
                  subscription: temp,
                }, { merge: true })
                  .then()
                  .catch((error) => {
                    console.error('Error writing document: ', error);
                  });

              }} >
              <FiX />
            </button>
          </div>)
      );
    }

  };
  // const edit = async event => {
  //   event.preventDefault()
  //   const { avatar } = event.target
  //   avatar && uploadImage(avatar)

  //   saveChanges();
  // }
  return (
    <div className='EditProfilePage'>
      {alert && <Alert title={alert.title}
        setAlert={setAlert}
        comment={alert.comment}
        options={alert.options}
      />}
      <div className=" EditProfilePage" style={{flexDirection: 'column'}}>
        
        <div className="DashboardBlock EditProfileDashboard" >
          <h3>General information</h3>
          {scsMsg === true && <div style={{}}><p style={{color:'var(--grn)'}}>Changes are saved</p></div>}
          {savingMsg == true && <div style={{ color: 'white' }}><p style={{ color: 'white' }}>Saving...</p></div>}
          {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', width: '100%', alignItems: 'center', }}>


            <div
              style={{ alignSelf: 'center', display: 'flex', flexDirection: 'column', maxWidth: 140 }}
            // onClick={() => { console.log('pickImage(); ') }}
            >
              <img alt='Profile_pitcture'
                src={auth.currentUser?.photoURL ? auth.currentUser?.photoURL : '/blank-profile-picture.png'}
                style={{ width: 120, height: 120, borderRadius: 5, margin: 10, objectFit: 'cover'}}
              />
              <button
                style={{ borderWidth: 0, height: 0, padding: 0 }}
                type='button'
                onClick={() => fileInput.current.click()}>
                <FiEdit style={{ position: 'absolute', fontSize: 30, left: 95, bottom: 15, color: "black", filter: 'drop-shadow(1px 1px 0.5px rgba(104, 102, 128, 0.5))'}} />
              </button>
            </div>

            <div >
              <p style={{ fontSize: 16, color: "var(--wht)" }}>Account Type :</p>
              <button
                style={{
                  color: accTypeSelShow ? "var(--red)" : "var(--wht)",
                  alignSelf: 'center',
                  borderWidth: 0,
                }}
                type="button"
                onClick={() => {
                  if (accTypeSelShow) {
                    setAccTypeSelShow(false);
                  } else {
                    setAccTypeSelShow(true);
                  }
                }}>
                {accTypeSelShow ? 'Cancel' : AccType}
                {accTypeSelShow ? <FiXCircle style={{ marginInline: 5 }} /> : <FiEdit style={{ marginInline: 5 }} />}
              </button>
            </div>
          </div>
          {accTypeSelShow && <div >
            <div style={{ display: 'grid', gap: 5, justifyContent: 'center', paddingBottom: 5, flexDirection: 'row', gridTemplateColumns: '1fr 1fr 1fr' }}>
              {AccTypes.map(item => <ItemYORP title={item}
                key={item}
                sel={AccType}
                onClick={() => {
                  setAccType(item); setChanges(true); setErr(null); showScsMsg(false);
                }} />)}
            </div>
            <p style={{ fontSize: 16, color: "var(--ltg)", textAlign: 'center', marginBottom: 10 }}>{accTypesDis[AccType]}</p>
          </div>}
          <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
          {AccType == 'Business' || AccType == 'Artist' &&
            <>
              <button className='btnYorp' style={{ width: "100%" }}>
                <Link to="/" style={{ padding: '5px' }}>
                  Mobile Pay
                  <FiEdit style={{ marginLeft: 15 }} />
                </Link>
                {
                  isMobilePay &&
                  <Link to="/" className='btnYorp' style={{ width: '100%' }}>
                    Balance
                    <FiDollarSign style={{ marginLeft: 15 }} />
                  </Link>
                }
              </button>
              <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
            </>
          }

          <form onSubmit={edit} style={{ display: 'flex', flexDirection: 'column', maxWidth: 'none', padding: 5 }}>
                <input
                  ref={fileInput}
                  style={{ display: 'none' }}
                  type="file"
                  id="avatar"
                  name="avatar"
                  accept="image/png, image/jpeg"
                  onInput={avatarInput=>{console.log(avatarInput.target, '(', avatarInput.target.value.length,')',  'changes:', changes, ); avatarInput.target.value.length !== 0 ? setChanges(true) : setChanges(false)}}
                />
            <label htmlFor="nname" className="label" >
              Username:
              <input
                className="editable"
                autocompletetype="off"
                placeholder="Enter Username"
                defaultValue={nname}
                name="nname"
                id="nname"
                type="text"
                onInput={nnameInput => {nnameInput.target.value !== nname ? setChanges(true) : setChanges(false); setnname(nnameInput.target.value)}}
              />
            </label>
            <label className="label" htmlFor="nemail">
              {/* <p className='uinfTxt'>Email: </p> */}
              Email:
              <input
                className="editable"
                autocompletetype="email"
                placeholder="Enter E-mail"
                type="email"
                defaultValue={nemail}
                name="nemail"
                id="nemail"
                onInput={nemailInput => {console.log(nemail); nemailInput.target.value !== nemail ? setChanges(true) : setChanges(false); setnemail(nemailInput.target.value)}}
              />
            </label>
            <label className="label" htmlFor="phN">
              {/* <p className='uinfTxt'>Phone #: </p> */}
              Phone #:
              <input
                className="editable"
                placeholder="Enter the phone #"
                autoCapitalize="none"
                autocompletetype="tel"
                defaultValue={phN}
                name="phN"
                id="phN"
                onInput={phNInput => {phNInput.target.value !== phN ? setChanges(true) : setChanges(false); setphN(phNInput.target.value)}}
              />
            </label>
            <label className="label" htmlFor="fbook">
              {/* <p className='uinfTxt'>Facebook: facebook.com/</p> */}
              facebook.com:
              <input
                className="editable"
                placeholder="Enter profile id"
                autoCapitalize="none"
                autocompletetype="off"
                defaultValue={fbook}
                name="fbook"
                id="fbook"
                onInput={fbookInput => {console.log('fbookInput.target.value', fbookInput.target.value);fbookInput.target.value !== fbook ? setChanges(true) : setChanges(false); setFaceBook(fbookInput.target.value)}}
              />
            </label>
            <label className="label" htmlFor="inst">
              {/* <p className='uinfTxt'>Instagram: instagram.com/</p> */}
              instagram.com:
              <input
                className="editable"
                placeholder="Enter profile id"
                autoCapitalize="none"
                autocompletetype="off"
                defaultValue={inst}
                name="inst"
                id="inst"
                onInput={instInput => {instInput.target.value !== inst ? setChanges(true) : setChanges(false); setinst(instInput.target.value)}}
              />
            </label>
            <label className="label" htmlFor="In">
              {/* <p className='uinfTxt'>LinkedIn: linkedin.com/in/</p> */}
              linkedin.com:
              <input
                className="editable"
                placeholder="Enter profile id"
                autoCapitalize="none"
                autocompletetype="off"
                defaultValue={In}
                name="In"
                id="In"
                onInput={InInput => {InInput.target.value !== In ? setChanges(true) : setChanges(false); setin(InInput.target.value)}}
              />
            </label>
            <label className="label" htmlFor="twit">
              {/* <p className='uinfTxt'>Twitter: twitter.com/</p> */}
              twitter.com:
              <input
                className="editable"
                placeholder="Enter profile id"
                autoCapitalize="none"
                autocompletetype="off"
                defaultValue={twit}
                onInput={twitInput => {twitInput.target.value !== twit ? setChanges(true) : setChanges(false); settwit(twitInput.target.value)}}
                name="twit"
                id="twit"
              />
            </label>
            {
            changes === true &&
            <button
              type="submit"
              style={{
                color: search ? "var(--red)" : "var(--wht)",
                alignSelf: 'center',
                borderWidth: 0,
                justifyContent: 'center',
                alignContent: 'center',
              }}>
              Save changes
              <FiCheckCircle style={{ marginInline: 5 }} />
            </button>
            }
          </form>
          <button
            style={{
              color: "var(--red)",
              alignSelf: 'center',
              borderWidth: 0,
            }}
            onClick={() => {
              setAlert({
                title: 'Delete Account',
                comment: 'This will permanently delete your account and all the associated information',
                options: [
                  { text: 'Cancel', style: 'cancel' },
                  {
                    text: 'Continue', onClick: () => {
                      const user = auth.currentUser;
                      user.delete().then(() => { navigateTo('/'); }).catch(e => { setErr(e); });
                    }, style: 'destructive',
                  },
                ],
              });
            }} >
            Delete Account
            <FiXCircle style={{ marginInline: 5 }} />
          </button>
        </div>
        
      </div>
      <div className=" EditProfilePage"  style={{height: '100%', flexDirection: 'column'}}>
        <div className='PlacesSubscription DashboardBlock centered ' style={{ width: '100%' }}>
          <h3
          // style={{ fontSize: 16, color: "var(--wht)", textAlign: 'center', marginBottom: 10, marginTop: 10 }}
          >
            Places Subscription</h3>
          <div style={{ paddingBottom: 5}}>
            <div style={{ alignItems: 'center', display: 'flex' }}>
              {renderPlacesSubscribed()}
              <button
                style={{
                  color: search ? "var(--red)" : "var(--wht)",
                  alignSelf: 'center',
                  borderWidth: 0,
                  justifyContent: 'center',
                  alignContent: 'center',
                }}
                onClick={() => {
                  if (search) {
                    setSearch(false);
                  } else {
                    setSearch(true);
                  }
                }}>
                {search ? 'Cancel' : 'Add Place'}
                {{ name: search } ? <FiXCircle style={{ marginInline: 5, }} /> : <FiPlusCircle style={{ marginInline: 5 }} />}
              </button>
            </div>
          </div>
          {/* {search && <PlaceSearch setErr={setErr} navigation={navigation} searchType="place" select={select} />} */}
            
        </div>
        {AccType === 'Artist' && PAccType === 'Artist' &&
         <div className="DashboardBlock EditProfilePage ArtistsInfo">
          <div style={{width: '100%'}}>
            <h3 style={{textAlign: 'center'}}>Artist info</h3>
          {scsMsgArt === true && <div style={{}}><p style={{color:'var(--grn)'}}>Changes are saved</p></div>}
          {savingMsg == true && <div ><p style={{color:'white'}}>Saving...</p></div>}
          {Err && <div><p >{Err}</p></div>}
          <form onSubmit={editArtist} style={{ display: 'flex', flexDirection: 'column', maxWidth: 'none', flex: 1, padding: 5 }}>
              {/* <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} /> */}
              <div style={{textAlign: 'center'}}>
                <label htmlFor="bio" className="EditArtistLabel" >
                  Bio:
                  <textarea
                    className="EditArtistInput"
                    style={{height: 50}}
                    placeholder="Enter profile id"
                    name='bio'
                    id='bio'
                    defaultValue={bio}
                    maxLength={500}
                    // multiline={true}
                    type='text'
                    onInput={bioInput => {console.log(bioInput.target.value, '(', bioInput.target.value.length,')',  'changes:',); bioInput.target.value !== bio ? setArtChanges(true) : setArtChanges(false); console.log(artChanges)}}
                  />
                </label>
              </div >
              <div style={{textAlign: 'center'}}>
                <label htmlFor="yt" className="EditArtistLabel" >
                  youtube.com:
                  <input
                    className="EditArtistInput"
                    placeholder="Enter profile id"
                    name='yt'
                    id='yt'
                    defaultValue={yt}
                    autoCapitalize="none"
                    autoComplete="off"
                    onInput={ytInput => {console.log(ytInput.target.value, '(', ytInput.target.value.length,')',  'changes:',); ytInput.target.value !== yt ? setArtChanges(true) : setArtChanges(false); console.log(artChanges)}}
                    // autoCorrect={false}
                    type='text'
                  />
                </label>
              </div>
              <div style={{textAlign: 'center'}}>
                <label htmlFor="sp" className="EditArtistLabel" >
                  open.spotify.com:
                  <input
                    className="EditArtistInput"
                    placeholder="Enter profile id"
                    name='sp'
                    id='sp'
                    defaultValue={sp}
                    autoCapitalize="none"
                    // placeholderTextColor={'var(--ltg)'}
                    autoComplete="off"
                    // autoCorrect={false}
                    type='text'
                    onInput={spInput => {console.log(spInput.target.value, '(', spInput.target.value.length,')',  'changes:',); spInput.target.value !== sp ? setArtChanges(true) : setArtChanges(false); console.log(artChanges)}}
                  />
                </label>
              </div>
              <div style={{textAlign: 'center'}}>
                <label htmlFor="sc" className="EditArtistLabel" >
                  soundcloud.com:
                  <input
                    className="EditArtistInput"
                    placeholder="Enter profile id"
                    name='sc'
                    id='sc'
                    defaultValue={sc}
                    autoCapitalize="none"
                    // placeholderTextColor={'var(--ltg)'}
                    type='text'
                    onInput={scInput => {console.log(scInput.target.value, '(', scInput.target.value.length,')',  'changes:',); scInput.target.value !== sc ? setArtChanges(true) : setArtChanges(false); console.log(artChanges)}}
                  />
                </label>
              </div>
              <div style={{textAlign: 'center'}}>
                <label htmlFor="mix" className="EditArtistLabel" >
                  mixcloud.com:
                  <input
                    className="EditArtistInput"
                    placeholder="Enter profile id"
                    name='mix'
                    id='mix'
                    defaultValue={mix}
                    autoCapitalize="none"
                    // placeholderTextColor={'var(--ltg)'}
                    autoComplete="off"
                    // autoCorrect={false}
                    type='text'
                    onInput={mixInput => {console.log(mixInput.target.value, '(', mixInput.target.value.length,')',  'changes:',); mixInput.target.value !== mix ? setArtChanges(true) : setArtChanges(false); console.log(artChanges)}}
                  />
                </label>
              </div>
              {
              artChanges && 
              <button 
                  style={{
                    display: 'none',
                    color: search ? "var(--red)" : "var(--wht)",
                    alignSelf: 'center',
                    borderWidth: 0,
                    justifyContent: 'center',
                    alignContent: 'center',
                  }}
                  // id="save-button"
                  type='submit'>
                Save changes <FiCheckCircle />
              </button>}
          </form>
        </div>
        </div>}
      </div>            
    </div>
  );
};

export default EditProfileScreen;